<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2023-03-28 09:39:47
 * @Description:
 * @LastEditors: fengxiaojing
-->
<template>
  <div class="h-100 position-absolute" id="roam_path" :style="{ height: height, top: top }">
    <div id="roam_list" :style="{ height: showPoint ? 'calc(50% - 10px)' : '100%' }">
      <el-row type="flex" align="middle" class="path_header business_dialog_title m-b-5">
        <el-col :span="10">
          <span class="fz-14">路径列表</span>
        </el-col>
        <el-col :span="14" class="flex flex-align-center">
          <el-switch
            :width="30"
            @change="loopListChange"
            v-model="isLoopList"
            active-text="列表循环"
            inactive-text="单个循环"
          >
          </el-switch>
          <el-tooltip effect="dark" content="新增路径" placement="top" :open-delay="1000">
            <el-button
              class="r path_header_button m-l-10"
              type="primary"
              @click="addPath"
              icon="iconfont icon-yxr-zj"
            ></el-button>
          </el-tooltip>
          <span class="iconfont icon-close r cur_pointer" @click="closeComponent"></span>
        </el-col>
      </el-row>
      <!-- 路径列表 -->
      <div class="path_table">
        <el-table :data="pathData" class="w-100" height="100%" ref="dragTable" :key="dragKey">
          <el-table-column label="序号" prop="seq" width="50"> </el-table-column>
          <el-table-column prop="name" label="路径名称" width="72"></el-table-column>
          <el-table-column prop="speed" label="播放速度" width="70"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <template v-if="currentPlayerId === scope.row.id">
                <el-tooltip placement="top" content="暂停" :open-delay="1000">
                  <el-button
                    type="danger"
                    icon="el-icon-video-pause"
                    @click="stopRoamPath(scope.row, $event)"
                  ></el-button>
                </el-tooltip>
              </template>
              <template v-else>
                <el-tooltip placement="top" content="播放" :open-delay="1000">
                  <el-button
                    type="success"
                    icon="el-icon-video-play"
                    @click="getRoamPathDetail(scope.row, $event)"
                  ></el-button>
                </el-tooltip>
              </template>
              <el-tooltip placement="top" content="编辑" :open-delay="1000">
                <el-button
                  type="primary"
                  icon="iconfont icon-edit"
                  @click="modifyPath(scope.row)"
                ></el-button>
              </el-tooltip>
              <el-tooltip placement="top" content="详情" :open-delay="1000">
                <el-button
                  type="primary"
                  icon="iconfont icon-list"
                  @click="detailPath(scope.row)"
                ></el-button>
              </el-tooltip>
              <el-tooltip placement="top" content="删除" :open-delay="1000">
                <el-button
                  type="danger"
                  icon="iconfont icon-close"
                  @click="deletePath(scope.row)"
                ></el-button>
              </el-tooltip>
              <el-tooltip placement="top" content="拖拽" :open-delay="1000">
                <el-button type="primary" class="handle" icon="iconfont el-icon-rank"> </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <div class="m-t-5 r">
        <el-pagination
          background
          @current-change="getRoamTraceList"
          :current-page.sync="page.pageNo"
          :page-size="page.pageSize"
          layout="total, prev, pager, next"
          :total="page.pageTotal"
        ></el-pagination>
      </div> -->
    </div>
    <div id="roam_point" v-if="showPoint">
      <!-- <div class="close-btn"></div> -->
      <el-row class="m-b-5">
        <el-col :span="12">
          <span class="fz-14">路径点列表</span>
        </el-col>
        <el-col :span="12">
          <i @click="closePoint" class="cur_pointer iconfont icon-close r"></i>
        </el-col>
      </el-row>
      <!-- 点列表 -->
      <div class="point_table">
        <el-table
          ref="pointTable"
          :data="currentParamList"
          class="w-100"
          height="100%"
          @cell-click="pointCell"
        >
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="eye" label="路径点坐标" width="170">
            <template #default="{row}">
              <span>{{ row.eye.join(', ') }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-tooltip placement="top" content="修改" :open-delay="1000">
                <el-button
                  type="primary"
                  icon="iconfont icon-edit"
                  @click="modifyPoint(scope.$index, currentParamList)"
                ></el-button>
              </el-tooltip>
              <el-tooltip placement="top" content="删除" :open-delay="1000">
                <el-button
                  type="danger"
                  icon="iconfont icon-close"
                  @click="deletePoint(scope.$index, currentParamList)"
                ></el-button>
              </el-tooltip>
              <el-tooltip placement="top" content="向下插入一行" :open-delay="1000">
                <el-button
                  type="primary"
                  icon="iconfont icon-add"
                  @click="insertPoint(scope.$index, currentParamList)"
                ></el-button>
              </el-tooltip>
              <el-tooltip placement="top" content="上移" :open-delay="1000">
                <el-button
                  v-if="scope.$index !== 0"
                  type="primary"
                  icon="iconfont icon-up"
                  @click="adjustPoint(scope.$index, scope.$index - 1, currentParamList)"
                ></el-button>
              </el-tooltip>
              <el-tooltip placement="top" content="下移" :open-delay="1000">
                <el-button
                  v-if="scope.$index < currentParamList.length - 1"
                  type="primary"
                  icon="iconfont icon-down"
                  @click="adjustPoint(scope.$index, scope.$index + 1, currentParamList)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="point_bottom m-t-5">
        <el-button type="success" size="mini" @click="startPlay(currentParamList, 'view')"
          >预览</el-button
        >
        <el-button type="primary" size="mini" @click="addPoint">增加路径点</el-button>
        <el-button type="primary" size="mini" @click="savePoint(currentParamList)">保存</el-button>
      </div>
    </div>
    <!-- 路径新增编辑弹框 -->
    <el-dialog
      :title="pathTitle"
      :visible.sync="pathFormVisible"
      width="400px"
      @close="cancelPath"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      v-dialogDrag
    >
      <el-form
        :model="pathForm"
        label-position="left"
        label-width="70px"
        :rules="addEditFormRules"
        ref="addEditForm"
      >
        <el-form-item label="序号" prop="seq">
          <el-input v-model.trim="pathForm.seq" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="路径名称" prop="name">
          <el-input v-model="pathForm.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="播放速度" prop="speed">
          <el-input v-model="pathForm.speed" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="iconfont icon-close" size="small" @click="cancelPath"
          >&nbsp;取 消</el-button
        >
        <el-button type="primary" class="iconfont icon-save" size="small" @click="submitPathForm"
          >&nbsp;确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import roamTrace from '@/services/roamTrace'
import { calcOffset, restore } from '@/components/model/js/calcOffset'
import Sortable from '@/assets/js/Sortable.js'

export default {
  name: 'RoamPathList',
  props: ['player', 'height', 'top', 'documentId', 'sceneOpenType', 'currentModel'],
  data() {
    const checkSeq = (rules, value, callback) => {
      if (!_.isSafeInteger(_.toNumber(value))) {
        callback(new Error('序号必须为整数类型'))
      } else {
        callback()
      }
    }
    return {
      dragKey: Math.random(),
      currentParamList: [],
      currentParam: {
        eye: '',
      },
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      showPoint: false,
      pathData: [],
      pathFormVisible: false,
      pathTitle: '',
      currentTraceId: '',
      currentPlayerId: '', // 当前播放的id
      pathForm: {
        siteId: '',
        code: '',
        name: '',
        speed: '',
        seq: '',
      },
      addEditFormRules: {
        seq: [
          { required: true, message: '请输入内容', trigger: 'change' },
          { required: true, validator: checkSeq, trigger: 'change' },
        ],
        name: [{ required: true, message: '请输入内容', trigger: 'change' }],
        speed: [
          { required: true, message: '请输入内容', trigger: 'change' },
          { required: true, validator: checkSeq, trigger: 'change' },
        ],
      },
      keyWord: '',
      speed: 20,
      isLoopList: false, // 是否循环列表
    }
  },
  watch: {
    documentId(val) {
      if (val) {
        this.getRoamTraceList()
      }
    },
  },
  created() {
    this.getRoamTraceList()
    this.setSort()
    this.player.Native.CameraAnimation.EventAnimationUpdate.connect((res) => {
      if (res.state === 2) {
        // 非循环模式下，到达endTime时通知
        // 监听当前项已经播放完成，获取接下来播放的row
        const curIndex = _.findIndex(this.pathData, ['id', this.currentTraceId])
        let nextIndex = 0
        if (curIndex < this.pathData.length - 1) {
          nextIndex = curIndex + 1
        }
        this.getRoamPathDetail(this.pathData[nextIndex])
      }
    })
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
    isLoadMap() {
      return this.sceneOpenType === 0
    },
  },
  methods: {
    // 更新拖拽顺序接口
    async updateSort(pathData) {
      const paramsObj = {}
      _.forEach(pathData, (val, index) => {
        paramsObj[String(val.id)] = index + 1
      })
      const res = await roamTrace.changeRoamTraceSeq(paramsObj)
      if (res && res.code === 0) {
        this.$message.success('更新排序成功！')
        this.getRoamTraceList()
      }
    },
    // 设置拖拽排序
    setSort() {
      this.sortable = null
      this.$nextTick(() => {
        const el = this.$refs.dragTable.$el.querySelectorAll(
          '.el-table__body-wrapper > table > tbody'
        )[0]
        this.sortable = Sortable.create(el, {
          ghostClass: 'sortable-ghost', // 放置占位符的类名
          handle: '.handle',
          setData: (dataTransfer) => {
            dataTransfer.setData('Text', '')
          },
          onEnd: (evt) => {
            console.log('拖拽结束', evt)
            const temp = this.pathData.splice(evt.oldIndex, 1)[0] // splice该方法会改变原始数组，返回被删除的项目集合
            this.pathData.splice(evt.newIndex, 0, temp)
            this.updateSort(this.pathData)
            this.dragKey = Math.random()
            this.setSort()
          },
          onStart: (evt) => {
            console.log(evt, '拖拽开始')
          },
        })
      })
    },
    closeComponent() {
      this.$emit('closeComponent', 'RoamPathList')
    },
    // 点击播放
    async getRoamPathDetail(row, event) {
      this.speed = row.speed
      this.currentTraceId = row.id
      this.currentPlayerId = row.id
      await this.getRoamTraceDetail()
      if (!this.currentParamList.length && this.isLoopList) {
        const curIndex = _.findIndex(this.pathData, ['id', this.currentTraceId])
        let nextIndex = 0
        if (curIndex < this.pathData.length - 1) {
          nextIndex = curIndex + 1
        }
        this.getRoamPathDetail(this.pathData[nextIndex])
      }
      await this.startPlay(this.currentParamList)
      this.concelFocus(event)
    },
    async getRoamTraceList() {
      const query = {
        pagesize: this.page.pageSize,
        pageno: this.page.pageNo,
        name: this.keyWord,
        documentId: this.currentModel.documentId,
      }
      const res = await roamTrace.getRoamTraceList(query)
      if (res && res.code === 0 && res.data) {
        this.pathData = _.sortBy(res.data, ['seq'])
        this.page.pageTotal = res.page.recordCount
        this.showPoint = false
      }
    },
    // 点击暂停
    async stopRoamPath(row, event) {
      console.log('当前需要暂停的', row, event)
      this.player.Native.CameraAnimation.setPaused(true) // 暂停播放
      this.currentPlayerId = ''
      this.concelFocus(event)
    },
    concelFocus(event) {
      let target = event.target
      if (target.nodeName === 'I') {
        target = event.target.parentNode
      }
      target.blur()
    },
    // 循环开关操作
    loopListChange(val) {
      if (val) {
        this.player.Native.CameraAnimation.setLoop(false)
      } else {
        this.player.Native.CameraAnimation.setLoop(true)
      }
    },
    // 获取当前相机参数
    async addPoint() {
      await this.getCameraInfo()
      this.currentParamList.push({
        detail: this.currentParam,
        eye: this.currentParam.eye,
      })
    },
    async getCameraInfo() {
      this.currentParam = await this.player.Native.CameraAnimation.cameraParam()
      // this.currentParam = await calcOffset(this.player, this.documentId)
    },
    /**
     * 通过速度求出点与点之间所需要的时间
     *  */
    getPointTime(start, end, speed) {
      const offset = Vec3.sub(start, end) // 向量相减
      const distance = Vec3.length(offset) // 向量的长度
      return distance / speed
    },
    // 添加关键帧
    async addKeyFrames(currentParam) {
      if (!_.isArray(currentParam)) {
        this.currentParamList.push({
          detail: this.currentParam,
          eye: this.currentParam.eye,
        })
      }
      const bool = await PlayerUtils.call(
        this.player.Native.CameraAnimation.addKeyFrames,
        this.currentParamList
      )
      this.currentParam = null
    },
    // 预览
    async startPlay(list, type) {
      this.player.Native.CameraAnimation.setPaused(false) // 	继续播放
      const keyFramesList = []
      await PlayerUtils.call(this.player.Native.CameraAnimation.clearKeyFrame) // 清除相机动画关键帧列表
      // 计算关键点所处的时间
      for (let index = 0; index < list.length; index++) {
        const element = list[index]
        // 根据偏移量计算当前相机参数
        // const Model_Offset = this.currentModel.attrObject.Model_Offset
        // element.detail = await restore(
        //   this.player,
        //   this.documentId,
        //   element.detail,
        //   Model_Offset,
        //   this.isLoadMap
        // )
        // 根据相机参数计算dir、right
        element.detail.dir = Vec3.normalize(Vec3.sub(element.detail.target, element.detail.eye))
        element.detail.right = Vec3.normalize(Vec3.cross(element.detail.dir, element.detail.up))
        if (index !== 0) {
          const time = this.getPointTime(list[index - 1].detail.eye, element.detail.eye, this.speed)
          element.detail.time = time + list[index - 1].detail.time
        } else {
          element.detail.time = 0
        }
        keyFramesList.push(element.detail)
      }
      const bool = await PlayerUtils.call(
        // 添加相机动画关键帧列表
        this.player.Native.CameraAnimation.addKeyFrames,
        keyFramesList
      )
      this.player.Native.CameraAnimation.setSpeed(this.speed) // 	设置播放动画组速度
      if (bool) {
        if (!this.isLoopList || type === 'view') {
          // 循环单个时
          this.player.Native.CameraAnimation.setLoop(true)
          this.player.Native.CameraAnimation.start()
        } else {
          // 循环列表时
          this.player.Native.CameraAnimation.setLoop(false)
          this.player.Native.CameraAnimation.start()
        }
      }
    },
    // 点击路径列表
    detailPath(row) {
      this.player.Native.CameraAnimation.stop() // 	停止播放动画组
      this.currentPlayerId = ''
      this.currentTraceId = row.id
      this.showPoint = true
      this.speed = row.speed
      this.getRoamTraceDetail()
    },
    // 关闭路径点列表
    closePoint() {
      this.showPoint = false
      this.currentParamList = []
      // 关闭预览动画
      this.player.Native.CameraAnimation.stop() // 	停止播放动画组
      this.currentPlayerId = ''
    },
    // 关闭弹窗
    cancelPath() {
      this.pathForm = this.$options.data().pathForm
      this.pathFormVisible = false
      this.$refs.addEditForm.resetFields()
    },
    //
    addPath() {
      this.pathFormVisible = true
      this.pathTitle = '新增路径'
      this.player.Native.CameraAnimation.stop() // 	停止播放动画组
      this.currentPlayerId = ''
    },
    //
    modifyPath(row) {
      this.pathFormVisible = true
      this.pathTitle = '编辑路径'
      this.pathForm = _.cloneDeep(row)
      this.player.Native.CameraAnimation.stop() // 	停止播放动画组
      this.currentPlayerId = ''
    },
    // 删除路径
    deletePath(row) {
      this.player.Native.CameraAnimation.stop() // 	停止播放动画组
      this.currentPlayerId = ''
      this.$confirm('是否确定删除当前路径?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await roamTrace.delRoamTrace([row.id])
        if (res && res.code === 0) {
          this.$message.success(res.msg)
          if (this.pathData.length === 1 && this.page.pageNo > 1) {
            this.page.pageNo -= 1
          }
          this.getRoamTraceList()
          this.showPoint = false
        }
      })
    },
    // 路径保存
    async submitPathForm() {
      this.$refs.addEditForm.validate(async (valid) => {
        if (valid) {
          this.player.Native.CameraAnimation.stop() // 	停止播放动画组
          this.currentPlayerId = ''
          // code === name
          this.pathForm.code = this.pathForm.name
          this.pathForm.siteId = this.currentProject.id
          this.pathForm.documentId = this.currentModel.documentId
          if (this.pathTitle === '新增路径') {
            const res = await roamTrace.saveRoamTrace(this.pathForm)
            if (res && res.code === 0 && res.data) {
              this.cancelPath()
              this.$message.success(res.msg)
              this.getRoamTraceList()
              this.showPoint = false
            } else {
              this.$message.error(res.message)
            }
          } else if (this.pathTitle === '编辑路径') {
            const res = await roamTrace.modifyRoamTrace(this.pathForm)
            if (res && res.code === 0 && res.data) {
              this.cancelPath()
              this.$message.success(res.msg)
              this.getRoamTraceList()
              this.showPoint = false
            } else {
              this.$message.error(res.message)
            }
          }
        }
      })
    },
    /**
     * 路径点相关
     */
    // 获取路径点信息
    async getRoamTraceDetail() {
      const query = {
        pagesize: 9999,
        pageno: 1,
        roam_trace_id: this.currentTraceId,
      }
      this.currentParamList = []
      const res = await roamTrace.getRoamTraceDetail(query)
      if (res && res.code === 0 && res.data) {
        const resList = _.sortBy(res.data, ['seq'])
        _.forEach(resList, (item) => {
          this.currentParamList.push({
            detail: JSON.parse(item.locationDetail),
            eye: JSON.parse(item.location),
          })
        })
      }
    },
    pointCell(row, column, cell, event) {
      if (column.label !== '操作') {
        // 移动相机
        this.$emit('moveCameraByVector', JSON.stringify(row))
      }
    },
    // 删除路径点
    deletePoint(index, rows) {
      // 关闭预览动画
      this.player.Native.CameraAnimation.stop() // 	停止播放动画组
      this.currentPlayerId = ''
      this.$confirm('是否确定删除?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        rows.splice(index, 1)
      })
    },
    // 修改路径点
    modifyPoint(index, rows) {
      // 关闭预览动画
      this.player.Native.CameraAnimation.stop() // 	停止播放动画组
      this.currentPlayerId = ''
      this.$confirm('是否确定修改为当前位置?', '修改', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        await this.getCameraInfo()
        this.$set(rows, index, { detail: this.currentParam, eye: this.currentParam.eye })
      })
    },
    // 插入一行
    async insertPoint(index, rows) {
      await this.getCameraInfo()
      if (this.currentParam) {
        const addObj = {
          detail: this.currentParam,
          eye: this.currentParam.eye,
        }
        this.currentParamList.splice(index + 1, 0, addObj)
      }
    },
    // 下移
    adjustPoint(index, targetIndex, rows) {
      const temp = rows[targetIndex]
      this.$set(rows, targetIndex, rows[index])
      this.$set(rows, index, temp)
    },
    // 保存路径点
    async savePoint(data) {
      // 请求参数
      const params = []
      if (!_.isEmpty(data)) {
        _.forEach(data, (item, index) => {
          const obj = {
            seq: index,
            location: JSON.stringify(item.eye),
            locationDetail: JSON.stringify(item.detail),
            siteId: this.currentProject.id,
          }
          params.push(obj)
        })
      }
      const query = {
        roam_trace_id: this.currentTraceId,
        detail: params,
      }
      const res = await roamTrace.updateRoamTraceDetail(query)
      if (res && res.code === 0) {
        this.getRoamTraceList()
        this.getRoamTraceDetail()
        this.$message.success(res.msg)
      } else {
        this.$message.error(res.message)
      }
      // 关闭预览动画
      this.player.Native.CameraAnimation.stop() // 	停止播放动画组
      this.currentPlayerId = ''
    },
  },
  beforeDestroy() {
    this.player.Native.CameraAnimation.stop()
    this.currentPlayerId = ''
  },
}
</script>
<style lang="scss" scoped>

@import '../../css/index.scss';
#roam_path {
  width: 368px;
  background-color: rgba(46, 107, 176, 0.5);
  border-radius: 2px;
  z-index: 99;
  right: 35px;
  padding: 10px;
  /deep/.el-switch.is-checked .el-switch__core {
    border-color: #00c0ff !important;
    background-color: #00c0ff !important;
  }
  /deep/.el-switch__label * {
    color: #999 !important;
    font-size: 12px !important;
  }
  /deep/.el-switch__label.is-active * {
    color: #fff !important;
  }
  .path_header {
    font-size: 16px;
    color: #fff;
    &_button {
      background-color: #00c0ff !important;
      width: 20px;
      height: 22px;
      text-align: center;
    }
  }
  .path_table {
    height: calc(100% - 54px);
  }
}
/deep/ .el-table__body-wrapper {
  background-color: transparent !important;
}
#roam_point {
  height: 50%;
  color: #fff;
  .point_table {
    height: calc(100% - 54px);
  }
  .point_bottom {
    margin: 5px;
    display: flex;
    justify-content: flex-end;
  }
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-button {
  margin-right: 7px;
}
.sortable-ghost {
  opacity: 0.8;
  background: rgba(36, 118, 224, 0.1) !important;
}

</style>
